import Vue from "vue";

export default {
  recuperarTiposTelefone() {
    return Vue.axios.get("tipoTelefone");
  },
};